import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { usePlan } from "@/context/PlanContext";
import { useLang } from "@/lib/i18n";
import api from "@/lib/api";
import { Check, Sparkles, ShieldCheck } from "lucide-react";

const FEATURES = [
  "Save unlimited daily entries",
  "History & calendar view",
  "Daily, Weekly, Monthly (MDCF) reports",
  "Annual & UC reports",
  "PDF & Excel downloads",
  "Share reports on WhatsApp",
  "Bulk month entry with carry-forward",
  "Valid for 365 days",
];

export default function Pricing() {
  const { user } = useAuth();
  const { openUpgrade } = usePlan();
  const { t } = useLang();
  const [price, setPrice] = useState(99);

  useEffect(() => {
    api.get("/payments/config").then(({ data }) => setPrice(data.price)).catch(() => {});
  }, []);

  const cta = () => {
    if (!user) { window.location.href = "/register"; return; }
    openUpgrade();
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid="pricing-page">
      <div className="text-center mb-8">
        <span className="inline-flex items-center gap-2 rounded-full bg-thali-green/10 text-thali-green px-3 py-1 text-sm font-bold mb-3">
          <Sparkles className="w-4 h-4" /> {t("pricing")}
        </span>
        <h1 className="text-3xl md:text-4xl font-heading font-extrabold">Simple, honest pricing</h1>
        <p className="text-thali-ink/70 mt-2">Public pages and the live demo calculator are always free. Saving, reports and downloads need a plan.</p>
      </div>

      <div className="card-thali max-w-md mx-auto overflow-hidden p-0" data-testid="pricing-card">
        <div className="bg-thali-green text-white p-6 text-center">
          <div className="text-sm opacity-80">{t("annual_plan")}</div>
          <div className="text-5xl font-num font-extrabold mt-1">₹{price}<span className="text-lg font-semibold opacity-80">/{t("year")}</span></div>
          <div className="text-xs opacity-80 mt-1">{t("incl_taxes")} · 365 days</div>
        </div>
        <div className="p-6">
          <div className="font-heading font-bold text-thali-green mb-3">{t("whats_included")}</div>
          <ul className="space-y-2">
            {FEATURES.map((f, i) => (
              <li key={i} className="flex items-start gap-2 text-sm"><Check className="w-4 h-4 text-thali-green mt-0.5 shrink-0" /> {f}</li>
            ))}
          </ul>
          <button onClick={cta} className="btn-3d-green w-full mt-5 text-lg" data-testid="pricing-cta">
            {user ? `${t("pay")} ₹${price}` : t("register_to_subscribe")}
          </button>
          {user && (
            <a href="/pay-qr" className="block text-center w-full mt-2 text-sm font-bold text-thali-ink/70 py-2" data-testid="pricing-qr-btn">📷 {t("qr_or_scan")}</a>
          )}
          <div className="flex items-center justify-center gap-1 text-xs text-thali-ink/50 mt-3">
            <ShieldCheck className="w-3.5 h-3.5" /> {t("secure_razorpay")}
          </div>
        </div>
      </div>
    </div>
  );
}
